import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import KlajdiPic from "../assets/klajdi.jpg";
import IdaPic from "../assets/ida.JPG";

export const Landing = () => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  // Update window height on resize or screen orientation change
  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      className="flex flex-col md:flex-row w-full"
      style={{ height: windowHeight }}
    >
      {/* Klajdi Section */}
      <div className="relative w-full md:w-1/2 h-1/2 md:h-full">
        <img
          src={KlajdiPic || "/placeholder.svg"}
          alt="Ask Klajdi"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
        <Link
          to="/question?askTo=Klajdi"
          className="w-1/2 absolute left-1/2 bottom-10 transform -translate-x-1/2 
          bg-white/40 backdrop-blur-md text-white text-lg md:text-xl font-semibold 
          px-8 py-3 rounded-lg transition-all duration-300 hover:bg-white/30 hover:scale-105 text-center"
        >
          Ask Klajdi
        </Link>
      </div>

      {/* Ida Section */}
      <div className="relative w-full md:w-1/2 h-1/2 md:h-full">
        <img
          src={IdaPic || "/placeholder.svg"}
          alt="Ask Ida"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
        <Link
          to="/question?askTo=Ida"
          className="w-1/2 absolute left-1/2 bottom-10 transform -translate-x-1/2 
          bg-white/40 backdrop-blur-md text-white text-lg md:text-xl font-semibold 
          px-8 py-3 rounded-lg transition-all duration-300 hover:bg-white/30 hover:scale-105 text-center"
        >
          Ask Ida
        </Link>
      </div>
    </div>
  );
};
